<template>
  <section class="user-detail--container">
    <div class="header">
      <asc-avatar
        v-if="!hideUserIcon"
        class="user-detail--avatar"
        :full-name="fullName"
        :is-internal="isUser"
      />
      <span v-if="hideUserIcon" class="user-detail--avatar-spacer"></span>
      <div
        class="userInfo"
        :style="{ flexDirection: isExpanded ? 'row' : 'column' }"
      >
        <span v-if="!newComment && !hideUserIcon" class="user-detail--name">
          {{ fullName }}
        </span>
        <span v-if="lastUpdated && !canEdit" class="user-detail--timestamp">
          {{ lastUpdated | dateTime }}
        </span>
      </div>
    </div>
    <div
      v-if="isUser && !newComment && !disabled && !canEdit"
      class="user-detail--menu"
    >
      <button class="user-detail--menu-button" @click="handleEditComment">
        <asc-tooltip tooltip="Edit" bottom>
          <v-icon :size="18" color="grey">edit</v-icon>
        </asc-tooltip>
      </button>
      <button class="user-detail--menu-button" @click="handleDeleteComment">
        <asc-tooltip tooltip="Delete" bottom>
          <v-icon :size="18" color="grey">delete</v-icon>
        </asc-tooltip>
      </button>
    </div>
  </section>
</template>

<script>
import AscAvatar from '@/components/atoms/AscAvatar'
import AscTooltip from '@/components/atoms/AscTooltip'
import { AscUserCommentPropsMixin } from '@/components/mixins'
import variables from '@/styles/_varsJs.scss'
import { getNewFormatUTCDateTime } from '@/utilities/dates'

export default {
  name: 'AscUserDetails',

  filters: {
    dateTime: function (value) {
      return getNewFormatUTCDateTime(value, true)
    },
  },

  components: {
    AscAvatar,
    AscTooltip,
  },

  mixins: [AscUserCommentPropsMixin],

  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
    fullName: {
      type: String,
      default: () => '',
    },
    newComment: {
      type: Boolean,
      default: () => false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    hideUserIcon: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getFontColor() {
      return variables.gray600
    },
  },

  methods: {
    handleDeleteComment() {
      this.$emit('onDeleteComment')
    },
    handleEditComment() {
      this.$emit('onEditComment')
    },
  },
}
</script>

<style lang="scss">
.user-detail {
  &--avatar {
    margin-right: $spacing-md;
  }

  &--avatar-spacer {
    margin-right: $spacing-md;
    min-width: 0px;
  }

  &--container {
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    position: relative;

    .header {
      display: flex;
      align-items: center;

      .userInfo {
        display: flex;
      }
    }
  }

  &--menu {
    display: flex;
    opacity: 0;

    &-button {
      padding: 3px;

      &:focus {
        background-color: $accent-200;
        outline: none;
        border-radius: 3px;
      }
    }
  }

  &--name {
    margin-right: $spacing-sm;
  }

  &--timestamp {
    color: $gray-600;
    margin-right: $spacing-md;
  }

  &:hover {
    .user-detail--menu {
      opacity: 1;
    }
  }
}
</style>
